import React, {useEffect, useState} from 'react'
import Page from '../Page'
import FilterSidebar from '../../Bars/FilterSidebar/FilterSidebar'
import Table from './Table/Table'
import {PropTypes} from 'prop-types'
import {observer} from 'mobx-react'
import Pagination from 'rc-pagination'
import './Sass/paginate.css'
import BreadCrumbsItems from '../BreadCrumbsItems/BreadCrumbsItems'

let TablePage = observer(props => {
    const [mobileVersion, setMobileVersion] = useState(true)
    const [showCount, setShowCount] = useState()

    const showCountChangeHandler = (e) => {
        setShowCount(e.target.value)
    }
    const showFilter = () => {
        setMobileVersion(!mobileVersion)
    }
    useEffect(() => {
        setMobileVersion(window.innerWidth < 1100)
        if (showCount) {
            props.showCountChanger(showCount)
        }
    }, [showCount])

    return (<>
            <FilterSidebar showFilter={showFilter}
                           filterComponent={props.filterComponent}
                           style={mobileVersion ? {display: 'none'} : {display: 'block'}}
                           filterChangeHandler={e => props.filterChangeHandler(e)}
                           filterDateRange={props.filterDateRange}
                           filterFieldsConf={props.filterFieldsConf}
                           filterChangeURL={props.filterChangeURL}
                           filterBarButtons={props.filterBarButtons}
                           exportTemplateButtons={props.exportTemplateButtons}
                           addOrg={props.addOrg}
            />
            <Page name={props.pageName} animation={'fade-in-fwd'} mobile={true}>
                <BreadCrumbsItems routes={props.breadCrumbsItems}/>

                <Table
                    loading={props.loading}
                    showFilterSidebar={showFilter}
                    title={props.tableTitle}
                    sortHandler={props.sortHandler}
                    firstRow={props.tableFirstRow}
                    haveToShow={props.tableHaveToShow}
                    tableStorage={props.tableStorage}
                    showCountChangeHandler={e => showCountChangeHandler(e)}
                    additionalId={props.additionalId}
                    pagination={props.pagination}
                />

                <div className='pagination'>
                    <div>
                        {props.loading && <div style={{
                            background: 'rgba(255,255,255,0.8)',
                            position: 'absolute',
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }}/>}
                        <Pagination showTitle={false} onChange={e => props.setActualPage(e)}
                                    current={props.pagination.offset}
                                    pageSize={props.pagination.limit} total={props.pagination.resultsCount}/>

                    </div>
                </div>
            </Page>
        </>
    )
})
TablePage.propTypes = {
    tableTitle: PropTypes.string.isRequired,
    tableStorage: PropTypes.array.isRequired,
    tableFirstRow: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            id: PropTypes.string,
            sortFunction: PropTypes.func,
            haveSort: PropTypes.bool
        })).isRequired,

    tableHaveToShow: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            type: PropTypes.string,
            typeData: PropTypes.object
        })),
    filterChangeHandler: PropTypes.func
}
TablePage.defaultProps = {
    addOrg: PropTypes.shape({
        med: false,
        org: false,
        patient: false
    })
}


export default TablePage
